import { Row, Col } from "react-bootstrap";
import SimpleCard from "../../common/simple-card";
import { FC, useState } from "react";
import { joinTimeParts } from "lib/utils/date-utils";
import SimpleList from "lib/components/common/simple-list";
import BookingDetailsTile from "../booking-details-tile";

interface PatientConfirmAppointmentProps {
  practitionerDates: string[];
  bookingSlots?: AppointmentBooking[];
  bookingSummary?: AppointmentBookingDetails;
  onSlotSelected?: (slot: AppointmentBooking) => void;
  onDateSelected?: (date: Date) => void;
  onBookingConfirmed?: (appointment: AppointmentBookingDetails) => void;
  mode?: "create" | "edit";
}

const PatientConfirmAppointment: FC<PatientConfirmAppointmentProps> = ({
  practitionerDates,
  bookingSlots = [],
  bookingSummary,
  onDateSelected,
  onSlotSelected,
  onBookingConfirmed,
  mode = "create",
}) => {
  const [selectedDateIndex, setSelectedDateIndex] = useState<number | null>(
    null
  );
  const [selectedSlotIndex, setSelectedSlotIndex] = useState<number | null>(
    null
  );

  const allSlots = bookingSlots.map(
    (slot) =>
      `${joinTimeParts(
        slot.fromTime.hour,
        slot.fromTime.minute
      )} - ${joinTimeParts(slot.toTime.hour, slot.toTime.minute)}`
  );

  const bookedSlots = bookingSlots
    .filter((slot) => slot.isBooked)
    .map(
      (slot) =>
        `${joinTimeParts(
          slot.fromTime.hour,
          slot.fromTime.minute
        )} - ${joinTimeParts(slot.toTime.hour, slot.toTime.minute)}`
    );

  return (
    <SimpleCard>
      <Row>
        <Col xs={12} md={4} className="mb-4 mb-md-0">
          <h5>Available Dates</h5>
          <small className="text-muted">
            Select the date to see available slots
          </small>
          <SimpleList
            items={practitionerDates}
            className="auto-scroll-350 mt-3"
            selectedItemIndex={selectedDateIndex}
            onItemClick={(itemIndex) => {
              setSelectedDateIndex(itemIndex);
              setSelectedSlotIndex(null);
              const selectedDate = new Date(practitionerDates[itemIndex]);
              onDateSelected?.(selectedDate);
            }}
          />
        </Col>
        <Col xs={12} md={4} className="mb-4 mb-md-0">
          <h5>Available Slots</h5>
          <small className="text-muted">Select the slot to book</small>
          <SimpleList
            items={allSlots}
            disabledItems={bookedSlots}
            className="auto-scroll-350 mt-3"
            selectedItemIndex={selectedSlotIndex}
            onItemClick={(itemIndex) => {
              setSelectedSlotIndex(itemIndex);
              onSlotSelected?.(bookingSlots[itemIndex]);
            }}
          />
        </Col>
        <Col xs={12} md={4}>
          <h5>Booking Summary</h5>
          <small className="text-muted">
            Review your booking details and click "Book Appointment" to confirm.
          </small>
          {bookingSummary && (
            <div className="mt-3">
              <BookingDetailsTile
                bookingDetails={bookingSummary}
                cancelAppointmentTitle="Book Appointment"
                onCancelAppointment={() => {
                  onBookingConfirmed?.(bookingSummary);
                }}
                mode={mode}
              />
            </div>
          )}
        </Col>
      </Row>
    </SimpleCard>
  );
};

export default PatientConfirmAppointment;
